"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectErrorView = AccountSelectErrorView;
var React = _interopRequireWildcard(require("react"));
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _SubtitleLayout = require("../../components/SubtitleLayout");
var _AccountSelectError = require("../../components/AccountSelectError");
var _tracking = require("../../utils/tracking");
var _HelpContainer = require("../HelpContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function AccountSelectErrorView(_ref) {
  let {
    retry,
    backToList,
    email,
    source
  } = _ref;
  const handleRetry = () => {
    retry(email);
  };
  const loginAnotherWay = () => {
    (0, _tracking.trackLoginAnotherWay)(source);
    backToList();
  };
  const handleHelpClick = React.useCallback(() => (0, _tracking.trackLoginNeedHelp)(source), [source]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, null, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"), /*#__PURE__*/React.createElement(_AccountSelectError.AccountSelectError, {
    onRetry: handleRetry,
    onChangeAccount: loginAnotherWay
  }), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    onClick: handleHelpClick
  }));
}